export default {
    data() {
        return {
            conditionGrades: [
                'SS',
                'M-',
                'VG+',
                'VG',
                'VG-',
                'G+',
                'G',
            ],
            conditionGrades78: [
                { text: 'N- (M-)', value: 'N-' },
                { text: 'E+ (VG+)', value: 'E+' },
                { text: 'E (VG)', value: 'E' },
                { text: 'E- (VG-)', value: 'E-' },
                { text: 'V+ (G+)', value: 'V+' },
                { text: 'V (G)', value: 'V' },
                { text: 'V- (G-)', value: 'V-' },
                { text: 'G', value: 'G' },
                { text: 'G-', value: 'G-' },
                { text: 'F', value: 'F' },
                { text: 'P', value: 'P' },
                { text: 'N (M)', value: 'N' },
                { text: 'SS', value: 'SS' }
            ],
        }
    }
}